import React from 'react';
import { NavLink } from 'react-router-dom';
import ListItem from 'pencil/ListItem';
import ListItemText from 'pencil/ListItemText';
import ListItemIcon from 'pencil/ListItemIcon';
import * as I18n from 'circe/I18n';

const ItemNavLink = ({
  classes,
  titleMapping,
  toggleDrawer,
  isSidebarItemActive,
  open,
  toUrl,
  itemKey,
  iconComponent,
  groupTitle,
  ...rest
}) => (
  <NavLink
    to={toUrl}
    className={classes.link}
    activeClassName={classes.activeLink}
    onClick={() => {
      toggleDrawer(itemKey, groupTitle);
    }}
    isActive={(match) => isSidebarItemActive(match, itemKey)}
    {...rest}
  >
    <ListItem button key={itemKey} className={classes.listItem}>
      <ListItemIcon>{iconComponent}</ListItemIcon>
      {open && (
        <ListItemText
          classes={{ primary: classes.itemText }}
          primary={I18n.str(itemKey, titleMapping[itemKey])}
        />
      )}
    </ListItem>
  </NavLink>
);

export default ItemNavLink;
